export const APP_VERSION = 'c06fccc2-1793580326';
